// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";

import { IAcademyDocumentFolder } from "../../Models/IAcademyDocumentFolder";
import { baseUrl } from "../../helpers/constants";

import { useNavigate } from "react-router-dom";
import AcademyDocumentFolder from "./AcademyDocumentFolder";
import DocumentViewer from "../../Controls/DocumentViewer";
import { helperMethods } from "../../helpers/helperMethods";

import { IAppUserDto } from "../../Models/IAppUserDto";
import authService from "../api-authorization/AuthorizeService";
import AcademyCommandBar from "./AcademyCommandBar";
import {
  Button,
  createTableColumn,
  Divider,
  Field,
  Link,
  MessageBar,
  MessageBarBody,
  ProgressBar,
  Tab,
  TableCellLayout,
  TableColumnDefinition,
  TabList,
  Text,
} from "@fluentui/react-components";
import LuebPagedDataGrid from "../../Controls/LuebPagedDataGrid";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  HatGraduationRegular,
  IosArrowRtl24Regular,
} from "@fluentui/react-icons";
import Header from "../Layout/Header";
import useWindowSize from "../../helpers/useWindowSize";
import HeaderTextAnimation from "../Layout/HeaderTextAnimation";

// Props
interface IAcademyHomeProps {}

// Function
function AcademyHome(props: IAcademyHomeProps) {
  const windowSize = useWindowSize();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [currentUser, setCurrentUser] = useState<IAppUserDto | undefined>(
    undefined,
  );

  const [selectedTab, setSelectedTab] = useState<string>("");
  const [selectedAcademySchulung, setSelectedAcademySchulung] =
    useState<IAcademyDocumentFolder>();

  const [academyDocumentFolders, setAcademyDocumentFolders] = useState<
    IAcademyDocumentFolder[]
  >([]);

  const [academyDocumentCategories, setAcademyDocumentCategories] = useState<
    string[]
  >([]);

  const [document, setDocument] = useState<any>(undefined);

  const getCurrentUser = () => {
    authService.getUser().then((user) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result: IAppUserDto) => {
            setCurrentUser(result);
          })
          .catch((error) => {});
      }
    });
  };

  useEffect(() => {
    if (academyDocumentFolders) {
      if (window.location) {
        if (window.location.search) {
          var search = window.location.search.split("=");
          var guid = search[1];
          if (guid) {
            var acadamySchulung = academyDocumentFolders.find(
              (item) => item.guid == guid,
            );
            if (acadamySchulung) {
              setSelectedAcademySchulung(acadamySchulung);
            }
          }
        } else {
          setSelectedAcademySchulung(undefined);
        }
      }
    }
  }, [academyDocumentFolders, window.location.search]);

  useEffect(() => {
    getCurrentUser();
    helperMethods.addAccessedModuleCountValue("Academy");
  }, []);

  const getMyAcademyDocumentFolders = () => {
    setIsLoading(true);
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/Academy/GetMyAcademyDocumentFolders`)
      .then((data: IAcademyDocumentFolder[]) => {
        const categories = data
          .map((item) => item.category)
          .filter((value, index, self) => self.indexOf(value) === index);

        const categoriesList = categories.filter((x) => x != undefined);
        setAcademyDocumentCategories(categoriesList);
        setSelectedTab(categoriesList[0]);

        setAcademyDocumentFolders(data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMyAcademyDocumentFolders();
  }, []);

  const columns: TableColumnDefinition<IAcademyDocumentFolder>[] = [
    createTableColumn<IAcademyDocumentFolder>({
      columnId: "name",

      renderHeaderCell: () => "Name",
      renderCell: (item) => (
        <TableCellLayout>
          <Link
            onClick={() => {
              setSelectedAcademySchulung(item);
              navigate("/academy?guid=" + item.guid);
            }}
          >
            {item.title}
          </Link>
        </TableCellLayout>
      ),
    }),
    createTableColumn<IAcademyDocumentFolder>({
      columnId: "zeitraum",

      renderHeaderCell: () => "Zeitraum",
      renderCell: (item) => (
        <TableCellLayout>
          {new Date(item.trainingDateFrom).toLocaleDateString() +
            " - " +
            new Date(item.trainingDateTo).toLocaleDateString()}
        </TableCellLayout>
      ),
    }),
    createTableColumn<IAcademyDocumentFolder>({
      columnId: "trainer",

      renderHeaderCell: () => i18n.t<string>("trainer"),
      renderCell: (item) => (
        <TableCellLayout>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {item.trainer
              ? item.trainer.map((trainer, index) => {
                  if (index == 1) {
                    return <div>{trainer.fullName}</div>;
                  } else {
                    return <div>{trainer.fullName}</div>;
                  }
                })
              : ""}
          </div>
        </TableCellLayout>
      ),
    }),
  ];
  const navigate = useNavigate();

  return (
    <>
      {document && (
        <DocumentViewer
          title={document.title}
          path={document.path}
          onDismiss={() => setDocument(undefined)}
          canDownload={true}
        />
      )}

      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1150 ||
              windowSize.width < 1024 ||
              !selectedAcademySchulung) && (
              <Button
                icon={<HatGraduationRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/academy");
                  setSelectedAcademySchulung(undefined);
                }}
              >
                ACADEMY
              </Button>
            )}
            {windowSize.width < 1151 &&
              windowSize.width > 1024 &&
              selectedAcademySchulung && (
                <Button
                  style={{ paddingLeft: "0px" }}
                  size="small"
                  onClick={() => {
                    navigate("/academy");
                    setSelectedAcademySchulung(undefined);
                  }}
                  appearance="transparent"
                >
                  <HatGraduationRegular fontSize={24} color="#ff6600" />
                </Button>
              )}
            {selectedAcademySchulung && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button size="large" appearance="subtle">
                  <HeaderTextAnimation
                    text={selectedAcademySchulung.title ?? ""}
                  />
                </Button>
              </div>
            )}
          </StackShim>
        }
      />
      {selectedAcademySchulung == undefined && (
        <>
          <AcademyCommandBar />
          <div className="lueb-ContentBlock">
            <h4>{i18n.t<string>("academyTitle")}</h4>
            {i18n
              .t("academyDescription")
              .split("\n")
              .map((item: string) => (
                <Text>{item}</Text>
              ))}
          </div>

          {!isLoading && academyDocumentFolders.length == 0 && (
            <MessageBar intent={"info"}>
              <MessageBarBody>
                {i18n.t<string>("noTrainingsFound")}
              </MessageBarBody>
            </MessageBar>
          )}

          {selectedTab && (
            <>
              <Divider
                appearance="brand"
                style={{ marginTop: "10px", marginBottom: "5px" }}
              >
                {i18n.t<string>("myTrainings")}
              </Divider>
              <TabList selectedValue={selectedTab}>
                {academyDocumentCategories.map((category: string) => {
                  return (
                    <Tab
                      onClick={() => {
                        setSelectedTab(category);
                      }}
                      value={category}
                    >
                      {i18n.t<string>(category)}
                    </Tab>
                  );
                })}
              </TabList>
              <div className="lueb-ContentBlock">
                <div>
                  <LuebPagedDataGrid
                    items={academyDocumentFolders.filter(
                      (x) => x.category == selectedTab,
                    )}
                    columns={columns}
                    resizableColumns
                    sortable
                    columnSizingOptions={{
                      name: {
                        minWidth: 300,
                        defaultWidth: 400,
                      },
                      zeitraum: {
                        minWidth: 200,
                        defaultWidth: 200,
                      },
                      trainer: {
                        minWidth: 200,
                        defaultWidth: 300,
                      },
                    }}
                  />
                  {isLoading && (
                    <Field validationState="none">
                      <ProgressBar />
                    </Field>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
      {selectedAcademySchulung != undefined && (
        <AcademyDocumentFolder
          allUsers={[]}
          isObserver={
            selectedAcademySchulung.academyDocumentFolder2AppUsers &&
            currentUser &&
            selectedAcademySchulung.academyDocumentFolder2AppUsers?.some(
              (x) => x.appUserGuid == currentUser?.id && x.isObserver,
            )
          }
          isAdmin={false}
          onRefreshRequested={() => getMyAcademyDocumentFolders()}
          academyDocumentFolder={selectedAcademySchulung}
        />
      )}
    </>
  );
}

// Export Function
export default AcademyHome;
